import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPerformanceBmpResultsMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitBmpResultInput;
}>;


export type SubmitPerformanceBmpResultsMutation = (
  { __typename: 'Mutation' }
  & { submitBmpResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitBmpResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'PerformanceResult' }
      & BmpAssessmentResultFragment
    )> }
  ) }
);

export type BmpAssessmentResultFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: (
    { __typename: 'BmpResult' }
    & BmpAssessmentResultDataFragment
  ) | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'March20kmResult' } | { __typename: 'SocResult' } | { __typename: 'WeightResult' } }
);

export type BmpAssessmentResultDataFragment = (
  { __typename: 'BmpResult' }
  & Pick<SchemaTypes.BmpResult, 'percentage'>
);

export const BmpAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment BmpAssessmentResultData on BmpResult {
  percentage
}
    `;
export const BmpAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment BmpAssessmentResult on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on BmpResult {
      ...BmpAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const SubmitPerformanceBmpResultsDocument = /*#__PURE__*/ gql`
    mutation SubmitPerformanceBmpResults($input: SubmitBmpResultInput!) {
  submitBmpResult(input: $input) {
    ... on SubmitBmpResultSuccessfulResponse {
      result {
        ...BmpAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${BmpAssessmentResultFragmentDoc}
${BmpAssessmentResultDataFragmentDoc}`;
export type SubmitPerformanceBmpResultsMutationFn = Apollo.MutationFunction<SubmitPerformanceBmpResultsMutation, SubmitPerformanceBmpResultsMutationVariables>;

/**
 * __useSubmitPerformanceBmpResultsMutation__
 *
 * To run a mutation, you first call `useSubmitPerformanceBmpResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPerformanceBmpResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPerformanceBmpResultsMutation, { data, loading, error }] = useSubmitPerformanceBmpResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPerformanceBmpResultsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPerformanceBmpResultsMutation, SubmitPerformanceBmpResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPerformanceBmpResultsMutation, SubmitPerformanceBmpResultsMutationVariables>(SubmitPerformanceBmpResultsDocument, options);
      }
export type SubmitPerformanceBmpResultsMutationHookResult = ReturnType<typeof useSubmitPerformanceBmpResultsMutation>;
export type SubmitPerformanceBmpResultsMutationResult = Apollo.MutationResult<SubmitPerformanceBmpResultsMutation>;
export type SubmitPerformanceBmpResultsMutationOptions = Apollo.BaseMutationOptions<SubmitPerformanceBmpResultsMutation, SubmitPerformanceBmpResultsMutationVariables>;